<div class="mixer-sidebars" id="mixer-sidebar" [class.hide]="is_fullscreen" [class.collapsed]="isCollapsed">

  <!-- Toggle button -->
  <button mat-icon-button class="toggle-button" (click)="toggleCollapse()"
    [matTooltip]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
    <i [class]="isCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
  </button>

  <!-- Collapsed view -->
  @if (isCollapsed) {
  <div class="collapsed-content">
    <button mat-icon-button class="collapsed-icon-button" (click)="onCollapsedAddDraft()" matTooltip="Add Draft">
      <i class="fas fa-chess-board"></i>
    </button>
    <button mat-icon-button class="collapsed-icon-button" (click)="onCollapsedCreateNote()" matTooltip="Add Note">
      <i class="fas fa-comment"></i>
    </button>
    <button mat-icon-button class="collapsed-icon-button" (click)="onCollapsedSearchClick()"
      matTooltip="Search Operations">
      <i class="fas fa-search"></i>
    </button>
  </div>
  }

  <!-- Expanded view -->
  @if (!isCollapsed) {
  <div class="full-mixer-sidebar">

    <mat-accordion multi>
      <!-- <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <i class="fas fa-eye"></i>
        View
      </mat-panel-title>

    </mat-expansion-panel-header>

    <button
      mat-icon-button
      matTooltip="pan" >
      <i class="fa-solid fa-hand"></i>
    </button>

    <button
      mat-icon-button
      matTooltip="select">
      <i class="fa-solid fa-hand-pointer"></i>
    </button>



    <button
      mat-icon-button >
      <i class="fa-solid fa-expand"></i>
    </button>



  </mat-expansion-panel>
  -->
      <mat-expansion-panel expanded hideToggle>

        <div class="edit-workspace">
          <button matButton="outlined" color="primary" matTooltip="Add Blank Draft" (click)="onAddDraft()">
            + <i class="fas fa-chess-board"></i> add draft
          </button>

          <button matButton="outlined" color="primary" matTooltip="Add Note" (click)="onCreateNote()">
            + <i class="fas fa-comment"></i> add note
          </button>
        </div>
        <div class="mixer-operations">
          <h4>operations</h4>

          <app-operation-search #operationSearch (addOperation)="onAddOperation($event)"></app-operation-search>

        </div>

      </mat-expansion-panel>




    </mat-accordion>
  </div>
  }

</div>